/**
 * Что здесь не так:
 * Если таких слайдеров будет на странице несколько, то события будут пересекаться
 * todo: fix
 */

export {};

$(companySliderSelectorInit);

NLMK.companySliderSelectorInit = companySliderSelectorInit;

function companySliderSelectorInit() {
    const companySliderSelector = '.company-slider__container';

    const debouncedInitialSlider = $.debounce(100, () => {
        NLMK.adaptiveBackgrounds();
    });

    $(companySliderSelector).each(function() {
        const $this = $(this);
        const $wrapper = $this.closest('.company-slider');
        let arrow = $wrapper.data('arrow');
        arrow = typeof arrow !== 'undefined' ? arrow : 'arrow-v3';
        const $currentSlide = $wrapper.find('.company-slider__current-slide');
        const $lastSlide = $wrapper.find('.company-slider__last-slide');
        const $arrowPrev = $wrapper.find(`.company-slider__${arrow}--prev`);
        const $arrowNext = $wrapper.find(`.company-slider__${arrow}--next`);

        $this.on('init', debouncedInitialSlider).slick({
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            fade: !!Modernizr.ie,
            useCSS: !Modernizr.ie,
            appendArrows: '.company-slider__nav',
        });

        const sliderNumbers = function() {
            const slick = $this.slick('getSlick');
            const slides = slick.$slides;
            const lastSlide = slides.length;

            $lastSlide.html(0 + lastSlide);
            $currentSlide.html(1);

            $this.on('afterChange', function(event, slick, currentSlide) {
                const number = currentSlide + 1;
                $currentSlide.html(0 + number);
            });
        };

        $arrowPrev.on('click', function() {
            $this.slick('slickPrev');
        });

        $arrowNext.on('click', function() {
            $this.slick('slickNext');
        });

        sliderNumbers();
    });
}



// WEBPACK FOOTER //
// ./js/main/module/sliders/company.js